module.exports = __webpack_public_path__ + "img/ari.65962457.png";